module.exports = __webpack_public_path__ + "img/waiting-warning.fcb4b70b.svg";